import {
  BellOutlined,
  LogoutOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import MobileMenu from "./MobileMenu";

import { useSelector } from "react-redux";
import { getMyProfile } from "../../redux-toolkit/slices/authSlice";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";

import { MenuProps } from "antd";
import {
  getAllChatsMetaApi,
  pushNewMessage,
  updateMeta,
} from "../../redux-toolkit/slices/chatSlice";
import { updateOrdersFromSocket } from "../../redux-toolkit/slices/ordersSlice";
import { socket } from "../../socketService";
import { useNavigate } from "react-router-dom";
type MenuItem = Required<MenuProps>["items"][number];
interface TopNavProps {
  menuItems: MenuItem[];
}
const TopNav: React.FC<TopNavProps> = ({ menuItems }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userProfile = useSelector((state: RootState) => state.auth.userProfile);
  const { selectedUser, meta } = useSelector((state: RootState) => state.chat);
  useEffect(() => {
    localStorage.setItem("email", userProfile?.email || "");
  }, [userProfile]);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  useEffect(() => {
    dispatch(getMyProfile());
    dispatch(getAllChatsMetaApi());
  }, []);

  const userRef = useRef(userProfile);
  const metaRef = useRef(meta);
  const selectedUserRef = useRef(selectedUser);

  // Keep refs updated
  useEffect(() => {
    userRef.current = userProfile;
  }, [userProfile]);

  useEffect(() => {
    metaRef.current = meta;
  }, [meta]);

  useEffect(() => {
    selectedUserRef.current = selectedUser;
  }, [selectedUser]);

  useEffect(() => {
    const handleMessage = (message: any) => {
      const user = userRef.current;
      const metaData = metaRef.current;
      const selected = selectedUserRef.current;
      const { sender } = message;
      console.log({ user, metaData, selected, sender });

      if (sender === selected?.userId?._id) {
        dispatch(
          pushNewMessage({
            _id: Math.random(),
            ...message,
            receiverId: user?.id,
            senderId: sender,
            isRead: false,
            updatedAt: message.createdAt,
          })
        );
        return;
      }

      const isAlready = metaData.find((item) => item.userId._id === sender);
      if (isAlready) {
        const _updatedMeta = metaData
          .map((item) => {
            if (item.userId._id === sender) {
              return {
                ...item,
                unreadCountForAdmin: (item.unreadCountForAdmin || 0) + 1,
                lastMessage: {
                  content: message.content,
                  createdAt: new Date(),
                },
              };
            }
            return item;
          })
          .sort((a, b) => {
            const dateA = new Date(a.lastMessage?.createdAt || 0).getTime();
            const dateB = new Date(b.lastMessage?.createdAt || 0).getTime();
            return dateB - dateA;
          });
        // dispatch your updated meta here
        dispatch(updateMeta(_updatedMeta)); // example
        return;
      }

      // If new user
      const _updatedMeta = [
        {
          _id: Math.random().toString(),
          userId: message.userId,
          lastMessage: {
            content: message.content,
            createdAt: new Date(),
          },
          unreadCountForAdmin: 1,
          unreadCountForUser: 0,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
        ...metaData,
      ];
      dispatch(updateMeta(_updatedMeta)); // example
    };
    const handleNewOrder = (orders: DashboardOrdersApiResponse) => {
      console.log({ orders });
      dispatch(updateOrdersFromSocket(orders));
    };
    socket.on("messageFromUser", handleMessage);
    socket.on("newOrderReceived", handleNewOrder);
    // return () => {
    //   socket.off("messageFromUser", handleMessage);
    // };
  }, []);
  useEffect(() => {
    if (userProfile) {
      socket.emit(
        "join",
        {
          userId: userProfile.id,
          client: "web",
        },
        () => {}
      );
    }
  }, [userProfile]);
  // useEffect(() => {
  //   socket.on("messageFromUser", (message) => {
  //     dispatch(
  //       pushNewMessage({
  //         _id: Math.random(),
  //         ...message,
  //         receiverId: userProfile?.id,
  //         isRead: false,
  //         updatedAt: message.createdAt,
  //       })
  //     );
  //   });
  // }, []);
  const styles = {
    menuRight: {
      display: "flex",
      alignItems: "center",
      position: "relative",
    } as React.CSSProperties,
    bellIcon: {
      fontSize: "24px",
      marginRight: "20px",
      cursor: "pointer",
    } as React.CSSProperties,
    userProfile: {
      display: "flex",
      alignItems: "center",
      padding: "5px 10px",
      border: "1px solid #e5e7eb",
      borderRadius: "20px",
      cursor: "pointer",
      position: "relative",
    } as React.CSSProperties,
    userName: {
      marginRight: "5px",
    } as React.CSSProperties,
    dropdown: {
      position: "absolute",
      top: "40%",
      right: "0",
      backgroundColor: "white",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      zIndex: 1,
      width: "150px",
      display: dropdownOpen ? "block" : "none",
    } as React.CSSProperties,
    dropdownItem: {
      padding: "10px 15px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      fontSize: "0.9rem",
      fontFamily: "'Libre Baskerville', serif",
    } as React.CSSProperties,
    dropdownIcon: {
      marginRight: "8px",
    } as React.CSSProperties,
  };
  return (
    <>
      <div className="desktop-menu-right" style={styles.menuRight}>
        <BellOutlined style={styles.bellIcon} />
        {userProfile && (
          <div style={styles.userProfile} onClick={toggleDropdown}>
            <span style={styles.userName}>
              {userProfile.firstName} {userProfile.lastName}
            </span>
            <span>&#9662;</span> {/* Downward arrow */}
            <div style={styles.dropdown}>
              <div style={styles.dropdownItem}>
                <SettingOutlined style={styles.dropdownIcon} />
                <span>Settings</span>
              </div>
              <div
                onClick={(e) => {
                  navigate("/news-letter");
                }}
                style={styles.dropdownItem}
              >
                <MailOutlined style={styles.dropdownIcon} />
                <span>News Letter</span>
              </div>
              <div
                onClick={(e) => {
                  navigate("/waiting-list");
                }}
                style={styles.dropdownItem}
              >
                <MailOutlined style={styles.dropdownIcon} />
                <span>Waiting list</span>
              </div>
              <div
                onClick={(e) => {
                  localStorage.clear();
                  window.location.href = "/";
                }}
                style={styles.dropdownItem}
              >
                <LogoutOutlined style={styles.dropdownIcon} />
                <span>Logout</span>
              </div>
            </div>
          </div>
        )}
      </div>
      <MobileMenu menuItems={menuItems} />
    </>
  );
};
export default TopNav;
